/* eslint-disable no-unused-vars */
import React, { Suspense, useState, useEffect } from "react";
import { createRoot } from 'react-dom/client';
import TopicsWidget from '../components/TopicsWidget';
import CommoditiesWidget from "../components/CommoditiesWidget";

const container = document.getElementById('search_records');
const root_search_records = createRoot(container); // createRoot(container!) if you use TypeScript

const fetchDisableTopics = () => {
  return [...JSON.parse(document.getElementById('filtered-topics-json').textContent)];
};

const fetchDisableCommodities = () => {
  return [...JSON.parse(document.getElementById('filtered-commodities-json').textContent)];
};

export function SearchRecords() {
  const [disableTopics, setDisableTopics] = useState(fetchDisableTopics);
  const [disableCommodities, setDisableCommodities] = useState(fetchDisableCommodities);
  // Update both states when any HTMX swap occurs
  useEffect(() => {
    const updateBoth = () => {
      setDisableTopics(fetchDisableTopics());
      setDisableCommodities(fetchDisableCommodities());
    };

    document.body.addEventListener('htmx:afterSwap', updateBoth);

    return () => {
      document.body.removeEventListener('htmx:afterSwap', updateBoth);
    };
  }, []);
  const handleTopicsUpdate = () => {
    setDisableCommodities(fetchDisableCommodities);
  };
  const handleCommoditiesUpdate = () => {
    setDisableTopics(fetchDisableTopics);
  };

  return (
      <div className="flex flex-col gap-6">
          <div>
              <span className="block py-1">Select topics</span>
              <Suspense fallback={<div>Loading...</div>}>
                  <TopicsWidget
                      uncheckables={container.getAttribute('uncheckables').split(',').map(Number)}
                      disableItems={disableTopics}
                      handleUpdate={handleTopicsUpdate}
                  />
              </Suspense>
          </div>
          <div>
              <span className="block py-1">Select commodities</span>
              <Suspense fallback={<div>Loading...</div>}>
                  <CommoditiesWidget
                      disableItems={disableCommodities}
                      handleUpdate={handleCommoditiesUpdate}
                  />
              </Suspense>
          </div>
      </div>
  );
}

root_search_records.render(
    <SearchRecords/>
);
/* eslint-enable no-unused-vars */
